export const getParam = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  const params = {};

  urlSearchParams.forEach((v, k) => (params[k] = v));

  return params;
};
